import { PropsWithChildren } from 'react'
import { Link } from 'react-router-dom'
import { styled } from '../../../lib/stitches'
import { Row } from '../../core/Components'
import { InternalEndpoint } from '../../Internal'
import { TopRightProfileCard } from '../../platform/dashboard/ProfileCard'
import { StyledContainer } from './common'

const StyledLink = styled(Link, {
  marginRight: '20px',
  '&:hover': { textDecoration: 'underline ' }
})

export const Layout: React.FC<PropsWithChildren> = ({ children }) => (
  <>
    <TopRightProfileCard />
    <Row
      justifySpaceBetween
      style={{
        padding: '10px 10px 10px 10px'
      }}
    >
      <Row>
        <StyledLink to={`/${InternalEndpoint}`}>Dashboard</StyledLink>
        <StyledLink to={`/${InternalEndpoint}/users`}>Users</StyledLink>
        <StyledLink to={`/${InternalEndpoint}/drafts-godlist`}>Drafts Godlist</StyledLink>
        <StyledLink to={`/${InternalEndpoint}/arp`}>Arp</StyledLink>
        <StyledLink to={`/${InternalEndpoint}/news`}>News</StyledLink>
        <StyledLink to={`/${InternalEndpoint}/sample-packs`}>Sample Packs</StyledLink>
        <StyledLink to={`/${InternalEndpoint}/arp-visualizer`}>Arp Visualizer</StyledLink>
        <StyledLink to={`/${InternalEndpoint}/redirects`}>Redirects</StyledLink>
      </Row>
    </Row>
    <StyledContainer>{children}</StyledContainer>
  </>
)
